/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Verify_EmailInputs */

const en_page_title_verify_email = /** @type {(inputs: Page_Title_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify email`)
};

const nl_page_title_verify_email = /** @type {(inputs: Page_Title_Verify_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail verifiëren`)
};

/**
* | output |
* | --- |
* | "Verify email" |
*
* @param {Page_Title_Verify_EmailInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_verify_email = /** @type {((inputs?: Page_Title_Verify_EmailInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Verify_EmailInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_verify_email(inputs)
	return en_page_title_verify_email(inputs)
});